'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from '@radix-ui/react-icons';
import * as React from 'react';
import { cn } from '../../../lib/utils';
const Accordion = AccordionPrimitive.Root;
const AccordionItem = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(AccordionPrimitive.Item, {
        ref: ref,
        className: cn('border-b', className),
        ...props
    }));
AccordionItem.displayName = 'AccordionItem';
const AccordionTrigger = /*#__PURE__*/ React.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ _jsx(AccordionPrimitive.Header, {
        className: "flex",
        children: /*#__PURE__*/ _jsxs(AccordionPrimitive.Trigger, {
            ref: ref,
            className: cn('flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180', className),
            ...props,
            children: [
                children,
                /*#__PURE__*/ _jsx(ChevronDownIcon, {
                    className: "h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200",
                    "aria-hidden": "true"
                })
            ]
        })
    }));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
const AccordionContent = /*#__PURE__*/ React.forwardRef(({ className, children, ...props }, ref)=>/*#__PURE__*/ _jsx(AccordionPrimitive.Content, {
        ref: ref,
        className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
        ...props,
        children: /*#__PURE__*/ _jsx("div", {
            className: cn('pb-4 pt-0', className),
            children: children
        })
    }));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
